var $22fbf25776bcbdd5$exports = {};
$22fbf25776bcbdd5$exports = {
  "backButton": args => "Reveni\u021Bi la ".concat(args.prevMenuButton),
  "moreActions": "Mai multe ac\u021Biuni",
  "unavailable": "Indisponibil, extinde\u021Bi pentru detalii"
};
export { $22fbf25776bcbdd5$exports as default };